import ApiNameToUpgradeProductMap from 'self-service-api/constants/ApiNameToUpgradeProductMap';
import * as CurrencyCodes from 'self-service-api/constants/CurrencyCodes';
export const isBuyingButtonProps = ctaProps => {
  if (typeof ctaProps !== 'object' || !ctaProps) {
    return false;
  }
  const props = ctaProps;
  const hasValidCurrency = Object.values(CurrencyCodes).includes(props.currencyCode);
  const hasValidProducts = Array.isArray(props.requestedProducts);
  if (!hasValidCurrency || !hasValidProducts) {
    return false;
  }

  // if requestedProducts has items, require terms validation
  if (props.requestedProducts.length > 0) {
    return typeof props.terms === 'object' && typeof props.terms.commitmentTerm === 'string' && typeof props.terms.paymentTerm === 'string';
  }
  return true;
};
export const isApiName = apiName => Object.hasOwn(ApiNameToUpgradeProductMap, apiName);